import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import loadingGif from '../../../assets/images/mp_loading2.gif'
import { theme } from '../../../theme/DashboardTheme'

const RemovalStatsModal = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        position: 'absolute',
        top: isMobile ? '15%' : '47%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: '#fff',
        p: 4,
        py: isMobile ? '48px' : '96px',
        borderRadius: 10,
        overflowY: 'auto',
        width: isMobile ? 'calc(100% - 12px)' : '80%',
        height: isMobile ? 'auto' : '65%',
        textAlign: 'center',
        boxShadow: '0px 4px 46px 0px rgba(0, 0, 0, 0.12)',
      }}
    >
      {/* Loading Icon */}
      <Box
        component="img"
        src={loadingGif}
        alt="Loading"
        sx={{
          width: isMobile ? 105 : 145,
          height: isMobile ? 105 : 145,
          display: 'block',
          margin: '0 auto 24px auto',
        }}
      />
      {/* Main Heading */}
      <Typography
        variant="h6"
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: isMobile ? 26 : 31,
          lineHeight: isMobile ? '30px' : '34px',
          color: '#3A155A',
          mb: isMobile ? '20px' : '29px',
          mt: isMobile ? '15px' : '25px',
        }}
      >
        Your scan is in progress
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body1"
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: isMobile ? 20 : 25,
          lineHeight: isMobile ? '30px' : '44px',
          color: '#6B7280',
        }}
      >
        This can take up to 24 hours.
        <br />
        We will email you when your results are complete.
      </Typography>
    </Box>
  )
}

export default RemovalStatsModal
